<template>
    <div>
        <b-button v-if="loading" variant="muted" squared><i class="fal fa-spin fa-spinner"></i></b-button>
        <div v-else-if="!loading">
            <b-button v-if="error" variant="warning" squared v-b-tooltip.hover :title="error"><i class="fa fa-exclamation-triangle"></i></b-button>
            <div v-else-if="!error">
                <div v-if="document" class="animated fade-in">
                    <div>
                        <img v-if="thumbable && viewable" :src="document_src" :width="width" height="auto" @click="show_preview = true" class="document-thumb" />
                        <span v-else-if="viewable"><b-button variant="sf" squared @click="show_preview = true"><i class="fal fa-eye"></i></b-button></span>
                        <span v-else-if="downloadable"><b-button variant="sf" squared @click="download"><i class="fal fa-download"></i></b-button></span>
                        <span v-else>N/A</span>
                    </div>
                    <c-modal :show.sync="show_preview" title="Preview" size="xl">
                        <img v-if="thumbable" :src="document_src" width="100%">
                        <iframe v-if="!thumbable && viewable" :src="document_src" width="100%" class="custom-iframe"></iframe>
                        <template #footer=""><span></span></template>
                    </c-modal>
                </div>
                <div v-else-if="!document" class="animated fade-in">
                    N/A
                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import ToastNotifications from "../shared/mixins/ToastNotifications";
  import image_mime_types from "./image_mime_types";
  import Document from "../../models/Document";

  const viewable_mime_types = ['application/pdf'];

  export default {
    name: 'DocumentPreview',
    components: {},
    mixins: [ToastNotifications],
    props: {
      document: {
        default: function () {
          return null;
        }
      },
      width: {
        default: function () {
          return 40;
        }
      },
      cache: {
        default: function () {
          return true;
        }
      },
    },
    data() {
      return {
        env: process.env.NODE_ENV,
        error: null,
        loading: true,
        thumbable: false,
        viewable: false,
        downloadable: false,
        document_src: null,
        show_preview: false
      };
    },
    watch: {
      document: {
        handler: function(curr, prev) {
          if(this.env === 'development') {
            this.error = 'Preview could not load';
            this.loading = false;
            return;
          }
          if(this.cache && prev && prev.id === curr.id) {
            return;
          }
          this.error = null;
          this.loading = true;
          this.thumbable = false;
          this.viewable = false;
          this.downloadable = false;
          image_mime_types.forEach((mime_type) => {
            if(this.document.mime_type === mime_type.Template) {
              this.thumbable = true;
            }
          });
          Document.api().file(this.document.id, this.document.mime_type, this.cache).then((response) => {
            let data = response.response.data;
            let type = this.document.mime_type;
            if(this.thumbable) {
              this.viewable = true;
              this.downloadable = true;
              let file = new Blob([data], {type: type});
              let urlCreator = window.URL || window.webkitURL;
              this.document_src = urlCreator.createObjectURL(file);
            } else {
              try {
                this.downloadable = true;
                let file = new Blob([data], {type: type});
                let urlCreator = window.URL || window.webkitURL;
                this.document_src = urlCreator.createObjectURL(file);
                if(viewable_mime_types.includes(this.document.mime_type)) {
                  this.viewable = true;
                }
              } catch (e) {
                this.viewable = false;
                this.downloadable = true;
              }
            }
            this.loading = false;
          }).catch(() => {
            this.error = 'Preview could not load';
            this.loading = false;
          });
        },
        immediate: true
      }
    },
    methods: {
      download() {
        window.open(this.document_src, '_blank');
      }
    },
  }
</script>